import NoteActions from 'actions/NoteActions';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as navigation from 'Navigation';
import preferences from 'Preferences';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {constructOptions, NOTE_TIMESTAMPS} from 'settings/visibility-options/VisibilityOptions';
import EntityStore from 'stores/EntityStore';
import APIUtil from 'util/APIUtil';

class NoteTab extends navigation.TabState {
  forDescription?: boolean;

  override defaults(): navigation.TabStateDefaults & {displayOptions: vo.VisibilityOptions} {
    const displayOptionsConfig = [
      {base: NOTE_TIMESTAMPS, visible: false, editable: true, sync: true},
      {base: vo.ELN_SPELL_CHECK, visible: false, editable: true, sync: true},
      {base: vo.ELN_PRINT_LAYOUT, visible: false, editable: true, sync: true},
      {
        base: vo.ELN_TABLE_OF_CONTENTS,
        visible: true,
        editable: true,
        sync: true,
      },
      {base: vo.ELN_SHOW_FORMULAS, visible: false, editable: true, sync: true},
      {base: vo.ELN_HIGHLIGHT_CUSTOM_COLUMNS, visible: false, editable: true, sync: true},
    ];

    if (BenchlingConfig.ELN_ENABLE_SHOW_API_IDS && preferences.get('ENABLE_COPY_API_ID')) {
      displayOptionsConfig.push({base: vo.NOTE_API_IDS, visible: false, editable: true, sync: true});
    }

    // Add read only mode option if feature flag is enabled or user has @benchling.com email
    if (BenchlingConfig.ELN_ENABLE_READ_ONLY_MODE || EntityStore.currentUserHasBenchlingEmail()) {
      displayOptionsConfig.push({
        base: vo.ELN_READ_ONLY_MODE,
        visible: false,
        editable: true,
        sync: true,
      });
    }

    return {
      ...super.defaults(),
      title: 'Notes',
      closeable: false,
      options: false,
      displayOptions: constructOptions('note', displayOptionsConfig),
      preferenceKey: 'note',
    };
  }

  override initialize(attributes: unknown, param: {forDescription: boolean}): void {
    if (param == null) {
      param = {forDescription: false};
    }
    const {forDescription} = param;
    this.forDescription = forDescription;
    this.set({
      fileId: this.get('model').id,
      fileType: APIUtil.apiIdToType(this.get('model').id),
      title: this.forDescription ? 'Description' : 'Notes',
    });

    // Keep name up-to-date so the NoteEditor has a reasonable title.
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.get('model'), 'change:name', this.setName);
    this.setName();

    // Load in note
    this.loadNote();
  }

  setName(): void {
    this.set(
      'name',
      [ModelTypeConstants.ENTRY, ModelTypeConstants.TEMPLATE].includes(this.get('fileType'))
        ? this.get('model').name()
        : `Notes for ${this.get('model').name()}`
    );
  }

  loadNote(): void {
    // Temporary until NoteStore is removed (in favor of stores with their own notes)
    if (this.forDescription) {
      NoteActions.load(this.get('model').id, this.get('model').initialNote());
    }
  }

  override cleanUp = (): void => {
    if (this.forDescription) {
      NoteActions.close(this.get('model').id);
    }
  };
}

export default NoteTab;
